module.exports = __webpack_public_path__ + "background-img.jpg?361d2a8ac2aeb9862530f491db6c69b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/background-img.jpg
// module id = 8
// module chunks = 0